import React, { Children } from "react";
import { AccordionItem } from "@radix-ui/react-accordion";
import PropTypes from "prop-types";
import { SidebarMenuItemContext } from "./SidebarMenuItemContext";
SidebarMenuItem.propTypes = {
    id: PropTypes.string.isRequired,
    children: PropTypes.node,
    className: PropTypes.string
};
export default function SidebarMenuItem(param) {
    var id = param.id, children = param.children, className = param.className;
    if (Children.count(children) > 2 || Children.count(children) === 0) {
        throw new Error("A SidebarMenuItem must have a SidebarMenuItemContent and, optionally, a SidebarMenuItemChildren.");
    }
    var childrenAsArray = Children.toArray(children);
    var hasSubmenu = childrenAsArray.length > 1;
    return /*#__PURE__*/ React.createElement(SidebarMenuItemContext.Provider, {
        value: {
            id: id,
            hasSubmenu: hasSubmenu
        }
    }, /*#__PURE__*/ React.createElement(AccordionItem, {
        value: id,
        className: className
    }, children));
}
